import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/page/Home'
import Discover from '@/components/page/Discover'
import News from '@/components/page/News'
import Advertising from '@/components/page/Advertising'
import About from '@/components/page/About'
import Join from '@/components/page/Join'
import Search from '@/components/page/Search'
import Detail from '@/components/page/Detail'
import NewsDetail from '@/components/page/NewsDetail'

Vue.use(Router)

export default new Router({
  base:'/dist/',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: Home,
      meta:{keepAlive: false}
    },
    {
      path: '/discover',
      name: 'discover',
      component: Discover,
      meta:{keepAlive: false},
      children:[
        
      ]
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta:{keepAlive: true}
    },
    {
      path: '/advertising',
      name: 'advertising',
      component: Advertising,
      meta:{keepAlive: false}
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta:{keepAlive: false}
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta:{keepAlive: false}
    },
    {
      path: '/join',
      name: 'join',
      component: Join,
      meta:{keepAlive: false}
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail,
      meta:{keepAlive: false}
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: NewsDetail,
      meta:{keepAlive: false}
    }
  ],
  // 设置vue每次路由跳转都是显示在该页面在最顶部
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


  



// WEBPACK FOOTER //
// ./src/router/index.js